<script lang="ts" module>
  import { Select } from 'bits-ui';
  import { tv } from 'tailwind-variants';

  import Icon from '@/ui/base/icon/Icon.svelte';

  import DropDownSelect, { type DropDownItem } from './DropDown/DropDownSelect.svelte';

  export interface DropDownProps {
    items: DropDownItem[];
    selected?: string;
    onItemClick?: (item: string) => void;
    disabled?: boolean;
    ariaLabel?: string;
  }
</script>

<script lang="ts">
  let { selected: selectedProp = $bindable(), ...props }: DropDownProps = $props();

  const styles = tv({
    base: 'flex items-center  gap-1 rounded-sm py-2 pl-2 pr-1 font-sans text-sm font-medium text-c-base',
    variants: {
      open: {
        true: 'bg-dropdown-S',
        false: 'bg-dropdown hocus:bg-dropdown-H',
      },
      disabled: {
        true: '!bg-dropdown-D',
        false: '',
      },
    },
  });

  let selectedLabel: string | undefined = $derived(
    selectedProp ? props.items.find((item) => item.value === selectedProp)?.label : undefined,
  );
  let isOpen: boolean = $state(false);
</script>

<Select.Root
  disabled={props.disabled}
  bind:open={isOpen}
  type="single"
  onValueChange={(v) => {
    selectedProp = v;
    props.onItemClick?.(v);
  }}
>
  <Select.Trigger
    class={styles({ open: isOpen, disabled: props.disabled })}
    aria-label={props.ariaLabel ?? 'Select'}
  >
    {selectedLabel ?? '...'}
    <Icon icon="KeyboardArrowDown" class="size-4" />
  </Select.Trigger>

  <Select.Portal>
    <Select.Content align="end" sideOffset={4}>
      <Select.Viewport class="grid gap-1 rounded-sm bg-dropdown-S p-1">
        {#each props.items as item (item)}
          <Select.Item value={item.value} label={item.label} disabled={item.disabled}>
            <DropDownSelect selected={item.value === selectedProp} {item}></DropDownSelect>
          </Select.Item>
        {/each}
      </Select.Viewport>
    </Select.Content>
  </Select.Portal>
</Select.Root>
